<template>
  <CustomerDetailPlaceholderTab title="Finanzas - Todos" />
</template>

<script>
import CustomerDetailPlaceholderTab from '@/components/customers/detail/tabs/CustomerDetailPlaceholderTab.vue';

export default {
  name: 'CustomerDetailFinanceAllTab',
  components: {
    CustomerDetailPlaceholderTab,
  },
};
</script>
